import React from 'react';
import mom_teaching_girl from '../../../assets/images/educational_service/mom_teaching_girl.jpg';
import { motion } from 'framer-motion';
import GradientButton from '../../../components/atoms/GradientButton';
import { useMediaQuery } from 'react-responsive';

function EducationalStaff() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <div className="bg-[#E8E8E8]">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20">
        <h2 className="text-[36px] sm:text-[50px] text-primary font-bold leading-tight mb-6">
          Guidepost Staff
        </h2>
        <div className="flex flex-col md:flex-row gap-8 lg:gap-14 ">
          <div className=" flex-[45%] text-secondary text-[18px] leading-relaxed flex flex-col gap-4">
            <p>
              Our staff consists of highly skilled professionals who specialize
              in occupational therapy, physical therapy, speech/dyslexia
              intervention therapies and behavioral health intervention. With
              their expertise and dedication, our caring staff members provide
              individualized care, support, and assistance to help children
              reach their full potential in all areas. Our occupational
              therapists address functional deficits impacting life skills,
              orthopedic diagnoses, sensory integration issues, feeding issues,
              fine motor skills and handwriting deficits, and more.
            </p>
            <p>
              Guidepost staff members are highly qualified therapists{' '}
              <span className="font-semibold">
                licensed by the State of Alaska Professional Licensing Board.
              </span>{' '}
              Each therapist has extensive experience working with children and
              they maintain a passion for that work evidenced in the results
              they produce.
            </p>
            <div className="mt-2">
              <GradientButton
                text="Meet Our Staff"
                width="w-full md:w-[240px] mb-4"
                navigateTo={'/our-team'}
              />
            </div>
          </div>
          <div className=" flex-[55%] flex ">
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src={mom_teaching_girl}
                alt="Occupational therapist guiding child in Wasilla session"
                className="rounded-2xl w-full"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EducationalStaff;
